








import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class FullscreenLoader extends Vue {
  @Prop({
    default: 'Loading...'
  })
  label: string

  @Prop()
  active: boolean
}
